import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Problem from "./Problem";
import Solution from "./Solution";
import Benefits from "./Benefits";
import Testimonials from "./Testimonials";
import CTA from "./CTA";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <Problem />
      <Solution />
      <Benefits />
      <Testimonials />
      <CTA />
      <Footer />
    </>
  );
};

export default Home;

